// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2aECD","name":"Header_name__2GOzd","birthday":"Header_birthday__1gCEP","skeleton":"Header_skeleton__QGs0s"};